import React from 'react';
import { Tooltip, TooltipProps } from 'antd';

type StandardUITooltipProps = Omit<TooltipProps, 'mouseEnterDelay'>;

/**
 * Standard UI Tooltip component that wraps antd's Tooltip with a fixed mouseEnterDelay of 0.6 seconds
 * @param props - All TooltipProps except mouseEnterDelay which is fixed
 * @returns StandardUITooltip component
 */
const StandardUITooltip = (props: StandardUITooltipProps) => {
  return <Tooltip {...props} mouseEnterDelay={0.6} />;
};

export default StandardUITooltip;

